// extracted by mini-css-extract-plugin
export default {"layout":"unknown-customer-layout_layout__gghu6"};